import { Team } from '@/api';
import { createContext } from 'react';

export interface TeamContextData {
    team: Team;
}
export const TeamContext = createContext<TeamContextData | undefined>(
    undefined
);
